import React, { memo } from 'react';

export const WallHorizontal: React.FC = memo(() => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 9H43.9995" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M24 4L24 8.99994" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M34 9L34 16.4999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M13.1641 9L13.1641 16.4999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M24 16.5L24 23.9999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M34 24L34 31.4999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M13.1641 24L13.1641 31.4999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M24 31.5L24 38.9999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M34 39L34 43.9999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M13.1641 39L13.1641 43.9999" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M4 16.5H43.9995" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M4 24H43.9995" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M4 31.5H43.9995" stroke="#464C5C" strokeWidth="1.25" />
    <path d="M4 39H43.9995" stroke="#464C5C" strokeWidth="1.25" />
    <rect
      x="4.625"
      y="4.625"
      width="38.7495"
      height="38.7495"
      rx="3.375"
      stroke="#464C5C"
      strokeWidth="1.25"
    />
  </svg>
));
